import moment from 'moment';

import { ProviderType } from 'src/modules/user/models/user';
import {
    DEFAULT_COACHING_SESSION_DURATION,
    DEFAULT_THERAPY_SESSION_DURATION,
} from 'src/modules/videoSessions/models/videoSessions';
import type { CoachingVisit } from 'src/modules/videoSessions/rematchModels/videoSessions';

export const convertSessionScheduledTimeToStartAndEndTime = (session: CoachingVisit) => {
    const { coachAssignment, scheduledDuration, scheduledTime } = session;

    const provider = coachAssignment?.coach;

    const defaultDuration =
        provider?.providerType === ProviderType.COACH
            ? DEFAULT_COACHING_SESSION_DURATION
            : DEFAULT_THERAPY_SESSION_DURATION; // defaultDuration is provided in seconds

    const visitDuration = scheduledDuration ? scheduledDuration : defaultDuration / 60; // in minutes
    const scheduledStartTime = moment(scheduledTime);
    const scheduledEndTime = scheduledStartTime.clone().add(visitDuration, 'minutes');

    return { scheduledEndTime, scheduledStartTime };
};
